<div class="p-0">
    <div class="modal-dialog modal-info-panel m-0" role="document">
        <bcu-local-spinner [size]="40" [visible]="(spinner$ | async).visible" *ngIf="(spinner$ | async).visible">
        </bcu-local-spinner>
        <div class="modal-content modal-info-panel"
            *ngIf="(blockedSlot$ | async).loaded && (blockedSlot$ | async).data as blockedSlot">
            <div class="modal-header info-panel-bg-color white">

                <div class="modal-title blocked-slot-info-title d-flex flex-column flex-grow-1">
                    <div class="flex-grow-1 text-right">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="flex-grow-1 text-center">
                        <div class="info-panel-title">{{ blockedSlot.type.name }}
                        </div>
                    </div>
                    <div class="flex-grow-1 text-center mt-1">
                        <div class="info-panel-sub-title" translate>BlockedSlot.Title</div>
                    </div>

                </div>

            </div>
            <div class="modal-body p-0 info-panel-players">

                <div class="blocked-slot-info-content d-flex flex-column p-3 info-panel-bg-color">
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_calendar"></span></div>
                        <div>{{blockedSlot.date | bcDate :"dddd, MMM Do YYYY"}}</div>
                        <div class="flex-grow-1 text-right">
                            <app-court-event-status-pill [infoPanel]="true" [status]="blockedSlot.status">
                            </app-court-event-status-pill>
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic-cb-time"></span></div>
                        <div>{{blockedSlot.timeFromInMinutes| timeDisplay}} -
                            {{blockedSlot.timeToInMinutes | timeDisplay}}
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_court"></span></div>
                        <div>{{blockedSlot.court.name}}<span *ngIf="blockedSlot.court.tennisType"
                                class="blocked-slot-tennis-type">
                                ({{blockedSlot.court.tennisType.name}})</span></div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_recurring"></span></div>
                        <div *ngIf="blockedSlot.recurring">
                            <div>{{ blockedSlot.recurring.daysOfWeek | bcWeekDays }}</div>
                            <div>{{ blockedSlot.recurring | bcRecurrenceEnds }}</div>
                        </div>
                        <div *ngIf="!blockedSlot.recurring" translate>BlockedSlot.IsNotRecurring</div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <hr class="solid bg-white" style="width: 100%;">
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <app-court-event-notes-info [notes]="blockedSlot.notes"></app-court-event-notes-info>
                    </div>
                    <div class="flex-grow-1 d-flex py-1">
                        <span class="clickable" (click)="onAddNote()">{{'BlockedSlot.AddNote' | translate}}</span>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <button class="btn btn-grey-outline flex-grow-1 mt-2" (click)="details()"
                            translate>BlockedSlot.DetailsButton</button>
                        <button class="btn btn-grey-outline flex-grow-1 mt-2 ml-1"
                            *ngIf="isCancellationAvailable(blockedSlot)" (click)="cancel()"
                            translate>BlockedSlot.CancelButton</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>